import LinearProgressBar from "@/components/progress/linear-progress-bar";
import { useSafeAreaStyles } from "@/hooks/utils/use-safe-area-styles";
import { IonHeader, IonToolbar } from "@ionic/react";
import { memo } from "react";
import { BackButton } from "../back-button";

interface StepToolbarComponentProps {
  totalStep: number;
  progress: number;
}

const StepToolbarComponent = memo(function StepToolbarComponent({
  progress,
  totalStep,
}: StepToolbarComponentProps) {
  const safeAreaStyles = useSafeAreaStyles();
  return (
    <IonHeader className="bg-white" style={{ ...safeAreaStyles }}>
      <IonToolbar
        className="max-w-[450px] safe-area-top mx-auto"
        style={{ ...safeAreaStyles }}
      >
        <div className="flex items-center w-full px-6 pt-4 bg-white">
          <BackButton isStepRoute />

          {totalStep !== 0 && (
            <>
              <LinearProgressBar className="flex-1 mx-8" value={progress} />
              <div className="w-9 h-9" aria-hidden="true" />
            </>
          )}
        </div>
      </IonToolbar>
    </IonHeader>
  );
});

export default StepToolbarComponent;
